import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Business from "../pages/business/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/business",
    element: <Business />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
